// The site hint (spec 210, CC-54621).
//
// Core's "Report Center" nav link opens `reports.centerbase.ai/login?site=<tenant>`.
// On the shared host the site is otherwise typed on a prompt (spec 033), so the hint
// is what lets a user who is already signed in to Core arrive here without one.
//
// The value comes from a URL, so anyone can write it. It only ever chooses WHICH
// firm's Auth0 sign-in to start — Auth0 still authenticates — and it is held to one
// DNS label because Login turns it into `<site>.centerbase.com` for the getorgid
// handshake: nothing in it may be able to name a different host.

const SITE_NAME = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/

/**
 * Read a `?site=` value.
 *
 * @param {string|null} raw  `searchParams.get('site')`
 * @returns {string|null} '' when the link carried no hint at all, null when it
 * carried one we cannot use (blank, or not a site name), else the site name.
 * The two empty answers are kept apart on purpose: a link that names no usable
 * site must never quietly fall back to whichever firm this browser remembers.
 */
export const parseSiteHint = (raw) => {
  if (raw == null) return ''
  const site = String(raw).trim().toLowerCase()
  return SITE_NAME.test(site) ? site : null
}

const SITE_CLAIM = 'https://centerbase.com/cbsite'

/**
 * The site a signed-in session belongs to, read from its access token's `cbsite`
 * claim (`vladdemo.centerbase.com` → `vladdemo`) — the same claim cb-api routes by.
 *
 * @param {string} token  an Auth0 access token
 * @returns {string|null} null when the token or the claim cannot be read
 */
export const siteOfAccessToken = (token) => {
  try {
    const parts = String(token).split('.')
    if (parts.length !== 3) return null
    const claims = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
    const host = claims?.[SITE_CLAIM]
    if (typeof host !== 'string' || !host) return null
    return host.split('.')[0].toLowerCase() || null
  } catch {
    return null
  }
}
